const setAfiDimensionGA = (afi) => {
  if (window.ga) {
    if (typeof window.ga !== 'undefined') {
      window.ga('set', 'dimension2', afi);
    }
  }
};

export default setAfiDimensionGA;
